import { FREE_HAND_TEXT_ELEMENTS as trans } from './translationValues';

export const freehandTextElements = (t, currentLanguage = 'en') => {
  return [
    {
      id: 1021,
      name: 'heading',
      isText: true,
      thumbnail: t(trans.HEADING_THUMBNAIL.key, trans.HEADING_THUMBNAIL.value),
      type: 'plain',
      elementDetails: {
        styles: {
          position: 'absolute',
          width: '600px',
          height: '110px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        value: t(trans.HEADING.key, trans.HEADING.value),
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              fontSize: 72,
              lineSpacing: 1.5,
              fontWeight: ['bold'],
              color: '#000000'
            },
            content: t(trans.HEADING_TEXT.key, trans.HEADING_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            content: "\n",
            style: {
              fontSize: 72,
              lineSpacing: 1.5,
              fontWeight: ['bold'],
              color: '#000000'
            }
          }
        ],
        type: 'text',
      },
    },
    {
      id: 1022,
      name: 'sub-heading',
      thumbnail: t(trans.SUB_HEADING_THUMBNAIL.key, trans.SUB_HEADING_THUMBNAIL.value),
      isText: true,
      type: 'plain',
      elementDetails: {
        styles: {
          position: 'absolute',
          width: '600px',
          height: '72px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
          background: 'transparent',
        },
        value: t(trans.SUB_HEADING.key, trans.SUB_HEADING.value),
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              fontSize: 42,
              lineSpacing: 1.5,
              fontWeight: ['bold'],
              color: '#000000'
            },
            content: t(trans.SUB_HEADING_TEXT.key, trans.SUB_HEADING_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            content: "\n",
            style: {
              fontSize: 42,
              lineSpacing: 1.5,
              fontWeight: ['bold'],
              color: '#000000'
            }
          }
        ],
        type: 'text',
      },
    },
    {
      id: 1023,
      name: 'body',
      thumbnail: t(trans.BODY_THUMBNAIL.key, trans.BODY_THUMBNAIL.value),
      isText: true,
      type: 'plain',
      elementDetails: {
        styles: {
          position: 'absolute',
          width: '250px',
          height: '26px',
          transform: 'translateX(0px) translateY(160px) rotate(0deg) scaleX(1) scaleY(1)',
        },
        value: t(trans.BODY.key, trans.BODY.value),
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            },
            content: t(trans.BODY_TEXT.key, trans.BODY_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            content: "\n",
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            }
          }
        ],
        type: 'text',
      },
    },
    {
      id: 1024,
      name: 'paragraph-1',
      thumbnail: t(trans.PARAGRAPH_THUMBNAIL.key, trans.PARAGRAPH_THUMBNAIL.value),
      isText: true,
      type: 'plain',
      elementDetails: {
        styles: {
          position: 'absolute',
          width: '610px',
          height: '100px',
          transform: 'translateX(0px) translateY(235px) rotate(0deg) scaleX(1) scaleY(1)',
        },
        value: t(trans.PARAGRAPH.key, trans.PARAGRAPH.value),
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            },
            content: t(trans.PARAGRAPH_TEXT.key, trans.PARAGRAPH_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            content: "\n",
            style: {
              lineSpacing: 1.5,
              fontWeight: [],
              color: '#000000'
            }
          }
        ],
        type: 'text',
      },
    },
  ];
};
